import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const coeurDaleneFaqs = [
  { q: "How do I get an expedited passport in Coeur d'Alene, Idaho?", a: "Coeur d'Alene residents can use Fast Passport Center for 2–9 day expedited processing. Ship your documents overnight and we handle agency submission remotely. The nearest regional agency is in Seattle, over 300 miles west across the Cascades." },
  { q: "Where is the nearest passport agency to Coeur d'Alene?", a: "The Seattle Regional Passport Agency (300 5th Ave, Seattle, WA) is approximately 300 miles west of Coeur d'Alene. It requires an appointment for emergencies only. Fast Passport Center eliminates that trip entirely." },
  { q: "What passport acceptance facilities are available in Coeur d'Alene?", a: "CDA has several facilities including the Main Post Office on N 7th St, the Kootenai County Clerk's Office on N Government Way, and post offices in Post Falls, Hayden, and Sandpoint. New applicants and minors must visit one of these in person." },
  { q: "Can I renew my passport by mail from Coeur d'Alene?", a: "Yes. If you are 16 or older, your passport is less than 15 years old, and it was issued after age 16, you can renew entirely by mail using DS-82. Fast Passport Center handles the whole process — no post office visit needed." },
  { q: "How long does a passport take from Coeur d'Alene?", a: "Through Fast Passport Center: 2–9 business days for expedited, 24 hours for life-or-death emergency. Routine post office processing takes 6–11 weeks. Standard post office expedited takes 3–5 weeks." },
  { q: "What airport should I fly out of from Coeur d'Alene?", a: "Spokane International Airport (GEG) is 30 miles west and is the nearest major airport for Coeur d'Alene travelers. It offers nonstop service to Seattle, Los Angeles, Denver, and other domestic hubs for international connections." },
  { q: "What if I'm applying for my child's passport near Coeur d'Alene?", a: "Children under 16 require both parents to appear at the acceptance facility, or a parent must provide notarized DS-3053 consent. We guide northern Idaho families through every parental consent requirement including the Kootenai County Clerk option." },
  { q: "Can I use my Coeur d'Alene address for passport delivery?", a: "Yes. Your new passport will be mailed directly to any U.S. address you provide, including your Coeur d'Alene home or office. Most expedited passports arrive within 1–2 business days of processing completion." },
];

export default function CoeurDalenePage() {
  return (
    <>
      <CitySEOHead
        city="Coeur d'Alene"
        state="Idaho"
        stateAbbr="ID"
        route="/coeur-dalene"
        title="Expedited & Emergency Passport Services Coeur d'Alene ID | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Coeur d'Alene, Idaho. Serving Kootenai County, Post Falls, Hayden, Sandpoint, and northern Idaho. As fast as 24 hours — no Seattle agency trip needed."
        geoPlacename="Coeur d'Alene, Idaho"
        geoPosition="47.6777;-116.7805"
        faqs={coeurDaleneFaqs}
        servicesSchema={[]}
        statePageName="Idaho"
        statePageRoute="/states/idaho"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <StickyNav />
        <ProcessingTimeSection />
        <LocalAreaSection />
        <ServicesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <AcceptanceFacilitiesSection />
        <ComparisonSection />
        <MistakesSection />
        <FAQSection />
        <HelpfulResourcesSection />
        <FinalCTA />
      </div>
    </>
  );
}